import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "inactive-player-area player-area-subarea" }
const _hoisted_2 = { class: "section cards" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_development_card = _resolveComponent("development-card")!
  const _component_card_deck = _resolveComponent("card-deck")!
  const _component_resource_card = _resolveComponent("resource-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_card_deck, {
        class: "development-cards",
        quantity: _ctx.player.developmentCardCount
      }, {
        "extra-card": _withCtx(() => [
          _createVNode(_component_development_card, {
            "no-icon": "",
            development: _ctx.resource
          }, null, 8, ["development"])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_development_card, {
            disabled: _ctx.player.developmentCardCount === 0
          }, null, 8, ["disabled"])
        ]),
        _: 1
      }, 8, ["quantity"]),
      _createVNode(_component_card_deck, {
        class: "resources",
        quantity: _ctx.player.resourcesCount
      }, {
        "extra-card": _withCtx(() => [
          _createVNode(_component_resource_card, { "no-icon": "" })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_resource_card, {
            disabled: _ctx.player.resourcesCount === 0
          }, null, 8, ["disabled"])
        ]),
        _: 1
      }, 8, ["quantity"])
    ])
  ]))
}